import React from 'react';
import PropTypes from 'prop-types';

import {dispatch, connect} from 'utils/state_manager';

import {Box, Divider} from 'views/components';
import {HoverToolBox, translate} from 'views/module';

import Message from './Message';
import EmailMessage from './EmailMessage';

import displayResource from 'utils/miscellaneous/display_resource';
import moment from 'moment';

const MessageFeedBox = (props) => {
  const [toolbarVisible, setToolbarVisible] = React.useState(false);
  const [mouseOver, setMouseOver] = React.useState(false);
  const [editMode, setEditMode] = React.useState(false);
  const [anchorEl, setAnchorEl] = React.useState(null);

  const {
    message,
    userRn,
    caregiverBackend,
  } = props;

  const isMessageTypeEmail = message.messageType === 'EMAIL';
  const emailBlob = message?.body?.blob;

  const parsedEmail = React.useMemo(() => {
    if (!isMessageTypeEmail) {
      return null;
    }

    return emailBlob;
  }, [emailBlob, isMessageTypeEmail]);

  React.useEffect(() => {
    if (editMode) {
      setToolbarVisible(false);
      return;
    }
    setToolbarVisible(mouseOver);
  }, [editMode, mouseOver]);

  const submittedBy = message.submittedBy;
  const author = displayResource(submittedBy);
  const timestampInfoCalculator = () => {
    const messageType = message.messageType;
    const createdAt = message.createdAt;

    let timestampPrefixLabel = null;
    switch (messageType) {
      case 'ANNOUNCEMENTS':
        timestampPrefixLabel = translate('caregiver.CaregiverDetail.Correspondance.Correspondance.AnnouncedOn');
        break;
      case 'COMMENTS':
        timestampPrefixLabel = translate('caregiver.CaregiverDetail.Correspondance.Correspondance.CommentedOn');
        break;
      case 'EMAIL':
        timestampPrefixLabel = translate('caregiver.CaregiverDetail.Correspondance.Correspondance.Email');
        break;
      default:
        timestampPrefixLabel = translate('caregiver.CaregiverDetail.Correspondance.Correspondance.CommentedOn');
        break;
    }

    const formattedTimestamp = moment(createdAt).format(translate('timeFormat.VerboseDay'));

    return `${timestampPrefixLabel} ${formattedTimestamp}`;
  };


  const onClickEdit = () => {
    setEditMode(true);
  };

  const onClickEditSave = (event, newMessage, setLoading) => {
    caregiverBackend.messages.update(message.messageRn, newMessage,
        () => {
          setEditMode(false);
        }, () => {
          setEditMode(false);
        });
  };

  const onClickEditCancel = () => {
    setEditMode(false);
  };

  const onEmojiSelected = (emoji) => {
    const prevMessage = message;
    const prevEmoji = prevMessage.emoji;
    // find if we previously selected this emoji, then remove, else add
    if (prevEmoji) {
      const prevEmojiUsers = prevEmoji[emoji];
      if (prevEmojiUsers) {
        const requesterIndex = prevEmojiUsers.findIndex((user) => user === userRn);
        if (requesterIndex > -1) {
          caregiverBackend.messages.removeEmoji(message.messageRn, emoji, userRn);
          return;
        }
      }
    }
    caregiverBackend.messages.addEmoji(message.messageRn, emoji, userRn);
  };

  const onClickDelete = (setIsDeleting) => {
    setIsDeleting(true);
    caregiverBackend.messages.delete(
        message.messageRn,
        () => setIsDeleting(false),
        () => setIsDeleting(false),
    );
  };
  return (
    <Box>
      <Divider/>
      <Box
        onMouseOver={(e) => setMouseOver(true) & setAnchorEl(e.currentTarget)}
        onMouseLeave={(e) => setMouseOver(false)}
        sx={{
          backgroundColor: toolbarVisible ? 'background.highlighted': 'inherit',
          px: {md: 2, xs: 1},
        }}
      >
        {
          isMessageTypeEmail &&
          <EmailMessage
            email={parsedEmail}
            timestampLabel={timestampInfoCalculator()}
          />
        }
        {
          !isMessageTypeEmail &&
          <Message
            userRn={userRn}
            fullName={author}
            message={message.body.blob}
            emojis={message.emoji}
            editMode={editMode}
            onClickSave={onClickEditSave}
            onClickCancel={onClickEditCancel}
            onEmojiSelected={onEmojiSelected}
            emojisWithRequesterData={message.emojisWithRequesterData}
            timestampLabel={timestampInfoCalculator()}
            truncate
          />
        }
        <HoverToolBox
          toolBar={toolbarVisible}
          anchorEl={anchorEl}
          copiedText={message.body.blob}
          onClickEdit={onClickEdit}
          onClickDelete={onClickDelete}
          onEmojiSelected={onEmojiSelected}
          hideTool={{
            emoji: isMessageTypeEmail,
            copy: isMessageTypeEmail,
            edit: isMessageTypeEmail || userRn !== message.submittedBy.resourceRn,
            delete: userRn !== message.submittedBy.resourceRn,
          }}
        />
      </Box>
    </Box>
  );
};
MessageFeedBox.propTypes = {
  message: PropTypes.object.isRequired,
  caregiverBackend: PropTypes.object.isRequired,
  userRn: PropTypes.string.isRequired,
};

const mapStateToProps = (state) => ({
  userRn: state.user.userRn,
});

export default connect(mapStateToProps, dispatch)(React.memo(MessageFeedBox));
